import { render, staticRenderFns } from "./applyForm_wx.vue?vue&type=template&id=508f7a74&scoped=true"
import script from "./applyForm_wx.vue?vue&type=script&lang=js"
export * from "./applyForm_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f7a74",
  null
  
)

export default component.exports